(function () {
  'use strict';

  if (window.AxiomUpsellProductsInitialized) return;
  window.AxiomUpsellProductsInitialized = true;

  function setActiveDot(root, activeIndex) {
    root.querySelectorAll('[data-upsell-dot]').forEach(function (dot, index) {
      var isActive = index === activeIndex;
      dot.classList.toggle('is-seen', index < activeIndex);
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function buildIndicatorButton(index) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'upsell-products__dot' + (index === 0 ? ' is-active' : '');
    dot.dataset.upsellDot = '';
    dot.dataset.upsellIndex = String(index);
    dot.setAttribute('aria-label', 'Show upsell product ' + (index + 1));
    dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
    return dot;
  }

  function visibleCardCount(root) {
    return root && root.classList.contains('upsell-products--layout-stacked') ? 2 : 1;
  }

  function syncNavigationState(root, count, activeIndex) {
    var previousButton = root.querySelector('[data-upsell-previous]');
    var nextButton = root.querySelector('[data-upsell-next]');
    var indicator = root.querySelector('[data-upsell-indicator]');
    var pageSize = visibleCardCount(root);
    var previousUnavailable = count <= pageSize || activeIndex <= 0;
    var nextUnavailable = count <= pageSize || activeIndex >= count - pageSize;
    var indicatorUnavailable = count < 2;

    if (previousButton) {
      previousButton.disabled = previousUnavailable;
      previousButton.hidden = previousUnavailable;
      previousButton.setAttribute('aria-disabled', previousUnavailable ? 'true' : 'false');
    }
    if (nextButton) {
      nextButton.disabled = nextUnavailable;
      nextButton.hidden = nextUnavailable;
      nextButton.setAttribute('aria-disabled', nextUnavailable ? 'true' : 'false');
    }
    if (indicator) {
      indicator.hidden = indicatorUnavailable;
      if (indicatorUnavailable) {
        indicator.setAttribute('aria-hidden', 'true');
      } else {
        indicator.removeAttribute('aria-hidden');
      }
    }
  }

  function syncIndicator(root, count, activeIndex) {
    var indicator = root.querySelector('[data-upsell-indicator]');
    syncNavigationState(root, count, activeIndex || 0);
    if (!indicator) return;

    if (count < 2) return;
    indicator.querySelectorAll('[data-upsell-dot]').forEach(function (dot) {
      dot.remove();
    });
    for (var index = 0; index < count; index += 1) {
      indicator.appendChild(buildIndicatorButton(index));
    }
    setActiveDot(root, activeIndex || 0);
  }

  function getActiveIndex(track) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-upsell-product-card], .upsell-products__item'));
    if (!cards.length) return 0;

    var currentLeft = track.scrollLeft;
    var activeIndex = 0;
    var closestDistance = Infinity;

    cards.forEach(function (card, index) {
      var cardLeft = card.offsetLeft - track.offsetLeft;
      var distance = Math.abs(cardLeft - currentLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function initRail(root) {
    if (!root || root.dataset.upsellRailBound === 'true') return;
    var track = root.querySelector('[data-upsell-track]');
    if (!track) return;

    root.dataset.upsellRailBound = 'true';
    var ticking = false;
    var autoplayTimer = null;
    var autoplayDelay = 5000;
    var autoplayStoppedByInteraction = false;
    var hoveredAutoplayTargets = new Set();
    var reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function updateDotsDuringScroll() {
      ticking = false;
      var activeIndex = getActiveIndex(track);
      setActiveDot(root, activeIndex);
    }

    function syncSettledState() {
      var cards = getCards();
      var activeIndex = getActiveIndex(track);
      syncNavigationState(root, cards.length, activeIndex);
      setActiveDot(root, activeIndex);
    }

    function getCards() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-upsell-product-card]'));
    }

    function scrollToCard(index, behavior) {
      var cards = getCards();
      var card = cards[index];
      if (!card) return;
      var left = card.offsetLeft - track.offsetLeft;
      track.scrollTo({ left: left, behavior: behavior || 'smooth' });
      syncNavigationState(root, cards.length, index);
      setActiveDot(root, index);
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      var cards = getCards();
      hoveredAutoplayTargets.forEach(function (target) {
        if (!target.isConnected || !root.contains(target)) hoveredAutoplayTargets.delete(target);
      });
      if (
        root.dataset.upsellAutoplay !== 'true' ||
        cards.length < 2 ||
        autoplayTimer ||
        autoplayStoppedByInteraction ||
        hoveredAutoplayTargets.size ||
        (reducedMotionQuery && reducedMotionQuery.matches)
      ) return;
      autoplayTimer = window.setTimeout(function () {
        autoplayTimer = null;
        if (!root.isConnected) {
          return;
        }
        cards = getCards();
        if (cards.length < 2) {
          return;
        }
        var currentIndex = getActiveIndex(track);
        var nextIndex = (currentIndex + 1) % cards.length;
        scrollToCard(nextIndex, 'smooth');
        startAutoplay();
      }, autoplayDelay);
    }

    function stopForInteraction() {
      autoplayStoppedByInteraction = true;
      stopAutoplay();
    }

    function handleNavigationClick(event) {
      var button = event.target.closest && event.target.closest('[data-upsell-previous], [data-upsell-next]');
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      stopForInteraction();

      var cards = getCards();
      if (cards.length < 2) return;

      var currentIndex = getActiveIndex(track);
      var direction = button.matches('[data-upsell-previous]') ? -1 : 1;
      var targetIndex = currentIndex + direction;
      if (targetIndex < 0 || targetIndex >= cards.length) return;
      scrollToCard(targetIndex, 'smooth');

      if (button.hidden) {
        var focusTarget = root.querySelector(direction > 0 ? '[data-upsell-previous]' : '[data-upsell-next]');
        if (focusTarget && !focusTarget.hidden) focusTarget.focus({ preventScroll: true });
      }
    }

    function bindHoverPauseTarget(target) {
      target.addEventListener('mouseenter', function () {
        hoveredAutoplayTargets.add(target);
        stopAutoplay();
      });
      target.addEventListener('mouseleave', function () {
        hoveredAutoplayTargets.delete(target);
        startAutoplay();
      });
    }

    function handleReducedMotionChange(event) {
      if (event.matches) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateDotsDuringScroll);
    }, { passive: true });
    track.addEventListener('scrollend', syncSettledState);

    root.querySelectorAll('.upsell-products__media, .upsell-products__title').forEach(bindHoverPauseTarget);
    root.addEventListener('focusin', stopForInteraction);
    root.addEventListener('touchstart', stopForInteraction, { passive: true });
    root.addEventListener('pointerdown', stopForInteraction);
    root.addEventListener('click', handleNavigationClick);
    track.addEventListener('wheel', stopForInteraction, { passive: true });
    if (reducedMotionQuery) reducedMotionQuery.addEventListener('change', handleReducedMotionChange);

    syncSettledState();
    startAutoplay();
  }

  function initRails(container) {
    (container || document).querySelectorAll('[data-upsell-products]').forEach(initRail);
  }

  function getStandardCartLines(cart) {
    return window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.getCartLines === 'function'
      ? window.AxiomStandardStorefront.getCartLines(cart)
      : [];
  }

  function standard() {
    return window.AxiomStandardStorefront || null;
  }

  function normalizeShopifyId(value, type) {
    var id = String(value || '');
    if (!id) return '';
    return id.replace(new RegExp('^gid://shopify/' + type + '/'), '').split('?')[0];
  }

  function getLineMerchandise(line) {
    return line && (line.merchandise || line.merchandiseId || line.variant || null);
  }

  function getLineProduct(line) {
    var merchandise = getLineMerchandise(line);
    return merchandise && merchandise.product ? merchandise.product : line && line.product ? line.product : null;
  }

  function getLineProductId(line) {
    var product = getLineProduct(line);
    return normalizeShopifyId(product && product.id, 'Product');
  }

  function getLineProductHandle(line) {
    var product = getLineProduct(line);
    return String(product && product.handle || line && line.handle || '').trim();
  }

  function getLineVariantId(line) {
    var merchandise = getLineMerchandise(line);
    var id = line && line.merchandiseId ? line.merchandiseId : merchandise && typeof merchandise === 'object' ? merchandise.id : merchandise;
    return normalizeShopifyId(id, 'ProductVariant');
  }

  function cardHasVariantId(card, variantIds) {
    var primaryVariantId = String(card.dataset.upsellVariantId || '');
    if (primaryVariantId && variantIds.has(primaryVariantId)) return true;

    return String(card.dataset.upsellVariantIds || '')
      .split(',')
      .some(function (variantId) {
        return variantId && variantIds.has(variantId);
      });
  }

  function removeMatchingCards(matchesCard) {
    var didSync = false;
    document.querySelectorAll('[data-upsell-products]').forEach(function (root) {
      var track = root.querySelector('[data-upsell-track]');
      if (!track) return;

      var didRemove = false;
      track.querySelectorAll('[data-upsell-product-card]').forEach(function (card) {
        if (matchesCard(card)) {
          card.remove();
          didRemove = true;
        }
      });

      if (!didRemove) return;
      didSync = true;

      var remainingCards = track.querySelectorAll('[data-upsell-product-card]');
      if (!remainingCards.length) {
        root.remove();
        return;
      }

      var activeIndex = Math.min(getActiveIndex(track), remainingCards.length - 1);
      syncIndicator(root, remainingCards.length, activeIndex);
    });
    return didSync;
  }

  function syncCartLineVariants(lines) {
    var cartVariantIds = new Set();
    (Array.isArray(lines) ? lines : []).forEach(function (line) {
      var variantId = getLineVariantId(line);
      if (variantId) cartVariantIds.add(variantId);
    });
    if (!cartVariantIds.size) return false;
    return removeMatchingCards(function (card) {
      return cardHasVariantId(card, cartVariantIds);
    });
  }

  function syncCartProducts(cart) {
    var lines = getStandardCartLines(cart);

    var cartProductIds = new Set();
    var cartProductHandles = new Set();
    var cartVariantIds = new Set();
    lines.forEach(function (line) {
      var productId = getLineProductId(line);
      var productHandle = getLineProductHandle(line);
      var variantId = getLineVariantId(line);
      if (productId) cartProductIds.add(productId);
      if (productHandle) cartProductHandles.add(productHandle);
      if (variantId) cartVariantIds.add(variantId);
    });
    if (!cartProductIds.size && !cartProductHandles.size && !cartVariantIds.size) return false;

    return removeMatchingCards(function (card) {
      var productId = String(card.dataset.upsellProductId || '');
      var productHandle = String(card.dataset.upsellProductHandle || '');
      return (
        cartProductIds.has(productId) ||
        cartProductHandles.has(productHandle) ||
        cardHasVariantId(card, cartVariantIds)
      );
    });
  }

  function requestCartSync() {
    var api = standard();
    if (!api || typeof api.getCart !== 'function') return Promise.resolve();
    return api.getCart().then(syncCartProducts).catch(function () {});
  }

  function addDirectBuy(button) {
    var api = standard();
    var variantId = String(button && button.dataset.variantId || '').trim();
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true' || !variantId || !api || typeof api.addLines !== 'function') return;

    var root = button.closest('[data-upsell-products]');
    var status = root && root.querySelector('[data-upsell-status]');
    var properties = {};
    if (button.dataset.manualPreorder === 'true') {
      properties[button.dataset.preorderPropertyName || '_manual_preorder'] = button.dataset.preorderPropertyValue || 'true';
    }

    if (button.dataset.directBuyAnimation === 'true' && window.AxiomAddToCartAnimation) {
      window.AxiomAddToCartAnimation.play({
        button: button,
        imageUrl: button.dataset.atcAnimationImage || '',
        mode: 'upsell'
      });
    }

    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    if (status) status.textContent = '';

    api.addLines({
      id: variantId,
      quantity: 1,
      properties: properties
    }, {
      target: button,
      source: 'upsell-direct-buy'
    }).catch(function (error) {
      if (status) status.textContent = error && error.message ? error.message : 'Unable to add this item to your bag.';
    }).finally(function () {
      if (!button.isConnected) return;
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-upsell-direct-buy]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addDirectBuy(button);
  });

  document.addEventListener('click', function (event) {
    var dot = event.target.closest && event.target.closest('[data-upsell-dot]');
    if (!dot) return;

    var root = dot.closest('[data-upsell-products]');
    var track = root && root.querySelector('[data-upsell-track]');
    if (!track) return;

    var cards = track.querySelectorAll('[data-upsell-product-card]');
    var index = parseInt(dot.dataset.upsellIndex, 10);
    var card = Number.isFinite(index) ? cards[index] : null;
    if (!card) return;

    event.preventDefault();
    track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    syncNavigationState(root, cards.length, index);
    setActiveDot(root, index);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initRails(event.target);
    requestCartSync();
  });

  document.addEventListener('axiom:recommendations:loaded', function (event) {
    if (!(event.target instanceof Element)) return;
    initRails(event.target);
  });

  document.addEventListener('shopify:cart:lines-update', function (event) {
    var syncPromise = event.promise
      ? event.promise.then(function (result) {
        if (!syncCartProducts(result && result.cart)) return requestCartSync();
      })
      : Promise.resolve(syncCartLineVariants(event.lines)).then(requestCartSync);
    syncPromise.then(function () {
      initRails(document);
    }).catch(function () {});
  });

  document.addEventListener('cart:drawer:rendered', function (event) {
    initRails(event.detail && event.detail.drawer ? event.detail.drawer : document);
  });

  document.addEventListener('cart:page:rendered', function (event) {
    initRails(event.detail && event.detail.cartPage ? event.detail.cartPage : document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRails(document);
      requestCartSync();
    });
  } else {
    initRails(document);
    requestCartSync();
  }
})();
